import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class ImportExportAPI {
  
  static importList = (filter, success, failure) => {
    fetch(Config.app.link + 'api/import/list', new Header('POST', { filter }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static importDelete = (id, success, failure) => {
    fetch(Config.app.link + 'api/import/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static exportList = (filter, success, failure) => {
    fetch(Config.app.link + 'api/export/list', new Header('POST', { filter }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static exportDelete = (id, success, failure) => {
    fetch(Config.app.link + 'api/export/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static exportModel = (module, filters, sorting, count, fields, model, success, failure, additional) => {
    let body = { id: 0, module, export_status: 1, filters, sorting, count, fields, model,
      timezone: new Date().getTimezoneOffset() };
    if(additional) {
      body = { ...additional, ...body };
    }
    fetch(Config.app.link + 'api/export', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  }
}
export default ImportExportAPI;